import { apiClient } from './client'
import type {
  Project,
  ConnectPlaneProjectInput,
} from '@/types/project'

export const projectsApi = {
  getAll: async (): Promise<Project[]> => {
    const response = await apiClient.get<Project[]>('/api/projects')
    return response.data
  },

  getById: async (id: string): Promise<Project> => {
    const response = await apiClient.get<Project>(`/api/projects/${id}`)
    return response.data
  },

  connectPlane: async (data: ConnectPlaneProjectInput): Promise<Project> => {
    const response = await apiClient.post<Project>('/api/projects/connect-plane', data)
    return response.data
  },
}
